

import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { MwcValidateStatus } from 'mwc/core/types';

@Injectable()
export class MwcFormStatusService {
  formStatusChanges = new ReplaySubject<{ status: MwcValidateStatus; hasFeedback: boolean }>(1);
}
